import moment from "moment";
import React from "react";

import planeLogo from "../../../images/planelogo.png";
import calculateTime from "../../../utils/calculateTime";
import customTime from "../../../utils/customTime";
import "../style.css";

const AirArabiaTicketDetail = ({
  data,
  passengerList,
  index,
  specialRequests,
}) => {
  function customDate(date) {
    let d = date?.split("T")?.[0];
    return moment(d).format("dddd DD MMM");
  }

  const getTicketNumber = (ticket) => {
    const rph = data?.rph.split("$")?.[2];
    for (let i = 0; i < ticket?.length; i++) {
      if (ticket[i]?.flightSegmentRPH?.toString() === rph.toString()) {
        return ticket[i];
      }
    }
    return null;
  };

  const getSeatAssignment = (seat) => {
    const rph = data?.rph.split("$")?.[4];
    const seatRph = seat?.flightRefNumberRPHList?.split("$")?.[4];

    if (seatRph === rph && data?.flightNumber === seat?.flightNumber) {
      return seat;
    }
    // for (let i = 0; i < seat?.length; i++) {
    //   if (seat[i]?.flightRefNumberRPHList?.toString() === rph.toString()) {
    //     return seat[i];
    //   }
    // }
    return null;
  };

  return (
    <div
      style={{
        // pageBreakInside: index && index % 2 === 0 ? "always" : "auto",
        pageBreakBefore: index && index % 2 === 0 ? "always" : "auto",
        marginTop: index && index % 2 === 0 ? "35px" : "0px",
      }}
    >
      <div className="line"></div>
      <div className="mt-1 mb-2 dep-daycar">
        <div className="flex justify-start space-x-1">
          <img src={planeLogo} alt="" style={{ width: "25px" }} />
          <div className="flex space-x-4 item-center">
            <h2 className="">
              DEPARTURE:{" "}
              <span className="text-lg font-bold">
                {customDate(data?.departureDateTime)}
              </span>
            </h2>
            <p className="mt-1 gray-color">
              Please verify flight times prior to departure
            </p>
          </div>
        </div>
      </div>
      {/* end of departure date header */}
      <div className="pass-details-card">
        <div className="pass-det gray-bg-color">
          <h2 className="text-2xl tracking-wide text-gray-700 font-bolder">
            Air Arabia
          </h2>
          <span className="bold">{data?.flightNumber}</span>

          <div className="my-1">
            <p>Duration:</p>
            <p>
              {calculateTime(data?.arrivalDateTime, data?.departureDateTime)}
            </p>
          </div>
          <div className="my-1">
            <p>Cabin:</p>
            <p>{data?.resCabinClass}</p>
          </div>
          <p className="my-1">Status: Confirmed</p>
        </div>
        <div className="pass-det-container">
          <div className="pass-det-2">
            <div className="pass-det-2-top">
              <div className="w-1/2">
                <p className="text-lg font-bolder">
                  {data?.departureAirport?.code}
                </p>
                <p className="tracking-wider">
                  {data?.departureAirport?.locationCode}
                </p>
              </div>
              <div className="w-1/2">
                <p className="text-lg font-bolder">
                  {data?.arrivalAirport?.code}
                </p>
                <p className="tracking-wider">
                  {data?.arrivalAirport?.locationCode}
                </p>
              </div>
            </div>
            <div className="pass-det-time">
              <div className="dep-time">
                <p className="tracking-wide text-gray-700">
                  Departing At: <br />
                  <span className="text-2xl font-bold">
                    {" "}
                    {customTime(data?.departureDateTime)}
                  </span>
                </p>
                <p>Terminal:</p>
                <p className="tracking-wide">
                  {data?.departureAirport?.terminal
                    ? data?.departureAirport?.terminal
                    : "Not Available"}
                </p>
              </div>
              <div className="arr-time">
                <p className="tracking-wide text-gray-700">
                  Arriving At: <br />
                  <span className="text-2xl font-bold">
                    {customTime(data?.arrivalDateTime)}
                  </span>
                </p>
                <p>Terminal:</p>
                <p className="tracking-wide">
                  {data?.arrivalAirport?.terminal
                    ? data?.arrivalAirport?.terminal
                    : "Not Available"}
                </p>
              </div>
            </div>
          </div>
          <div className="mt-2 space-y-2 pass-plane">
            <h1>Flight Number: {data?.flightNumber}</h1>
          </div>
        </div>
      </div>
      <div className="mt-12 pass-bottom sm:mt-2">
        <div className="bottom-pass-details gray-bg-color">
          <p>Passenger Name:</p>
          <p>Seats:</p>
          <p>eTicket Receipt(s):</p>
        </div>
        <div className="bottom-pass-details">
          <div className="flex flex-col">
            {passengerList?.map((passenger, i) => (
              <p key={i}>
                {">> "}
                {(passenger?.title || passenger?.name?.title) &&
                  `${passenger?.title || passenger?.name?.title}. `}
                {passenger?.name?.givenName
                  ? passenger?.name?.givenName + " " + passenger?.name?.surname
                  : passenger?.firstName + " " + passenger?.lastName}
              </p>
            ))}
          </div>

          <div className={`${passengerList?.[0]?.middle ? "-ml-24" : "ml-3"}`}>
            {specialRequests?.[0]?.seatRequests?.map((seat, i) => {
              return seat ? (
                <p>{getSeatAssignment(seat)?.seatNumber}</p>
              ) : (
                <p>Check-In Required</p>
              );
            })}
          </div>
          <div className="">
            {passengerList?.map((passenger, i) => (
              <div key={i}>
                {/* {passenger?.eTicketInfo?.[0]?.eTicketNo ||
                  passenger?.eTicket?.ticketNumber} */}
                {passenger?.eTicketInfo &&
                  getTicketNumber(passenger?.eTicketInfo)?.eTicketNo}
                {passenger?.eTicket && passenger?.eTicket?.length > 1
                  ? getTicketNumber(passenger?.eTicket)?.ticketNumber
                  : passenger?.eTicket?.ticketNumber}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AirArabiaTicketDetail;
